import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Grid, TextField } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import _ from 'lodash';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function CustomizedDialogs({ loading, onClose, handleSubmit, data, }) {

  return (
    <BootstrapDialog
      onClose={onClose}
      open={true}
    >
      <BootstrapDialogTitle onClose={onClose}>
        Bank details
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Grid
          container
          rowSpacing={2}
          columnSpacing={3}
          sx={{ alignItems: "center", py: 2 }}
        >
          <Grid item md={4} xs={4}>
            <Typography variant="subtitle1" >
              Bank name
            </Typography>
          </Grid>
          <Grid item md={8} xs={8}>
            <TextField
              fullWidth
              variant='standard'
              value={data?.bankdetail?.bank_name}
              disabled={true}
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={4}>
            <Typography variant="subtitle1">
              Account name
            </Typography>
          </Grid>
          <Grid item md={8} xs={8}>
            <TextField
              fullWidth
              variant='standard'
              value={data?.business_entity_name}
              disabled={true}
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={4}>
            <Typography variant="subtitle1">
              Account number
            </Typography>
          </Grid>
          <Grid item md={8} xs={8}>
            <TextField
              fullWidth
              variant='standard'
              value={data?.account_number}
              disabled={true}
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={4}>
            <Typography variant="subtitle1">
              Payout amount
            </Typography>
          </Grid>
          <Grid item md={8} xs={8}>
            <Typography>$ {data?.payout_amount}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      {
        data?.status === 'Pending' && <DialogActions sx={{ m: 1 }}>
          <LoadingButton loading={loading} onClick={() => handleSubmit(data?.id)} variant='outlined' color='error'>
            Payment Completed
          </LoadingButton>
        </DialogActions>
      }
    </BootstrapDialog>
  );
}